export const TriangleIcon = () => {
  const points = "50,10 90,85 10,85"; // top, bottom-right, bottom-left
  return (
    <svg width="40" height="40" viewBox="0 0 100 100">
      <polygon points={points} fill="#fff" stroke="#333" strokeWidth="2" />
    </svg>
  );
};